import { useLocation } from "react-router";

const SignUpBtn = () => {
  const location = useLocation();

  return (
    <div
      className={`sign-up-btn-view ${
        location.pathname === "/articles" ? "sign-up-btn-another-view" : ""
      }`}
    >
      <a
        className={`sign-up-btn font-amaticsc-bold ${
          location.pathname === "/articles" ? "sign-up-another-btn" : ""
        }`}
        href="/register"
      >
        Take a Class!
        <span className="btn-text font-kleeone-bold">今すぐ登録！</span>
      </a>
    </div>
  );
};

export default SignUpBtn;
